/** What a reservation's badge says. A cancelled reservation stays listed with `CANCELLED`. */
export type ReservationState = 'SCHEDULED' | 'ONGOING' | 'COMPLETED' | 'CANCELLED'

export interface ReservationTimes {
  start: Date | string
  end: Date | string
  cancelledAt?: Date | string | null
}

/**
 * Cancellation wins over time; then the end instant counts as completed and the start instant as ongoing, as for
 * events (`eventPhase`).
 */
export function reservationState(reservation: ReservationTimes, now: Date): ReservationState {
  if (reservation.cancelledAt) {
    return 'CANCELLED'
  }
  if (new Date(reservation.end) <= now) {
    return 'COMPLETED'
  }
  return new Date(reservation.start) <= now ? 'ONGOING' : 'SCHEDULED'
}

/**
 * Why the premise may no longer edit or cancel a reservation, or `null` when it may. Everything can change before
 * the start; from the start on nothing does (a past reservation is the record of what happened), and a cancelled
 * one is final. The internal note is not covered: staff may annotate a reservation at any time.
 */
export function reservationEditLock(reservation: ReservationTimes, now: Date): 'cancelled' | 'started' | null {
  if (reservation.cancelledAt) {
    return 'cancelled'
  }
  return new Date(reservation.start) <= now ? 'started' : null
}
